import { catchError, map, finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
  HttpClient,
} from '@angular/common/http';
import { HttpError } from 'src/app/shared/constants/http-error-code';
import { ToastService } from '../services/toast.service';
import { isProd } from 'src/app/shared/constants/env';
import { } from 'src/app/shared/utils/utils-global';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private httpClient: HttpClient,
    private toastService: ToastService,
  ) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    let newHeaders = req.headers;
    if (!newHeaders.has('Content-Type')) {
      newHeaders = newHeaders.append(
        'Content-Type',
        'application/json, text/plain, */*',
      );
    }
    if (!newHeaders.has('Accept')) {
      newHeaders = newHeaders.append('Accept', 'application/json');
    }
    const authReq = req.clone({ headers: newHeaders });

    return next.handle(authReq).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && !environment.production) {
        }
        return event;
      }),
      catchError((errorResponse: HttpErrorResponse) => {
        const {
          message: messageError,
          error: { message, error },
          url,
          status,
        } = errorResponse;

        if (!isProd()) {
          console.debugEx(
            '---------------------------ERRORS------------------------------------',
          );
          console.debugEx('Request URL: ', authReq.method, url);
          console.debugEx('Status code: ', status);
          console.debugEx('Detail errors:', error || messageError);
          console.debugEx(
            '----------------------------END--------------------------------------',
          );
        }

        const userMessage = message ?? messageError;

        switch (status) {
          case HttpError.BadRequest:
            this.toastService.showWarn(userMessage);
            break;

          case HttpError.Unauthorized:
            this.toastService.showWarn(userMessage);
            break;

          case HttpError.NotFound:
            this.toastService.showWarn(userMessage);
            break;

          case HttpError.TimeOut:
            this.toastService.showError(userMessage);
            break;

          case HttpError.Forbidden:
            this.toastService.showError(userMessage);
            break;

          case HttpError.InternalServerError:
            this.toastService.showError(
              'Internal server error, please contact Service Desk.',
            );
            break;
          default:
            this.toastService.showError(
              'Something went wrong, please try again',
            );
            break;
        }
        return throwError(error);
      }),
      finalize(() => { }),
    );
  }
}
